import { companyUnitListingGateway } from '~/gateways/companyUnitListingGateway';
import { MagicUseCase } from '../magicUseCase';

export class SetLikedUseCase extends MagicUseCase {
  protected async runLogic(params: { unitId: string; isLiked: boolean }) {
    await companyUnitListingGateway.setLiked(params.unitId, params.isLiked);
  }
}
